function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { Attributes, ValueText } from '@leverege/ui-attributes';
import React from 'react';
class FotaLoaderRenderer extends React.Component {
  async componentDidMount() {
    const {
      data,
      attrName,
      objectType,
      context
    } = this.props;
    // const { row : { original } } = data
    const toLoad = Attributes.getAttribute(attrName, objectType);
    toLoad?.load?.(data?.data, context);
  }
  componentDidUpdate(prevProps) {
    const {
      data,
      attrName,
      objectType,
      context
    } = this.props;
    const toLoad = Attributes.getAttribute(attrName, objectType);
    const val = toLoad?.get(data, context);
    if (!val) {
      toLoad?.load?.(data?.data, context);
    }
  }
  render() {
    const {
      data,
      context,
      attrName,
      objectType,
      originalValue,
      valueStyle
    } = this.props;
    // const { row : { original } } = data
    const value = Attributes.get(attrName, objectType, data?.data);
    const renderCell = context?.renderer?.renderCell;
    return renderCell ? renderCell({
      ...data,
      value
    }, this.props, context) :
    /*#__PURE__*/
    // This ensures we render the default value if it is set
    React.createElement(ValueText, {
      style: valueStyle
    }, value ?? originalValue ?? null);
  }
}
const createColumnRenderer = (attrName, objectType) => {
  return function ConnectedWrappedFotaLoaderRenderer(data, props, context) {
    const {
      row: {
        original
      }
    } = data;
    return /*#__PURE__*/React.createElement(FotaLoaderRenderer, _extends({}, props, {
      data: original,
      context: context,
      attrName: attrName,
      objectType: objectType
    }));
  };
};
const createDetailRenderer = (attrName, objectType) => {
  return function ConnectedWrappedFotaLoaderRenderer(value, style, object, context) {
    return /*#__PURE__*/React.createElement(FotaLoaderRenderer, {
      valueStyle: style,
      originalValue: value,
      data: object,
      context: context,
      attrName: attrName,
      objectType: objectType
    });
  };
};
export { createColumnRenderer, createDetailRenderer };
export default {
  createColumnRenderer,
  createDetailRenderer
};